import { PRINTER_SLICE_NAME, printerReducer } from './printerGlobalState.slice';

export const printerGlobalStateConfig = {
  name: PRINTER_SLICE_NAME,
  reducer: printerReducer,
} as const;
